import { createApi } from "@reduxjs/toolkit/query/react";
import apiBaseQuery from "./axiosBaseQuery";

export const INPUT_GROUP_API_REDUCER_KEY = "inputGroupApi";

export const inputGroupApi = createApi({
  reducerPath: INPUT_GROUP_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["input-group", "emission-activites"],
  endpoints: (builder) => ({
    createInputGroup: builder.mutation({
      query: (body) => ({
        url: `/emissions/emission-input-groups/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["input-group"],
    }),

    getInputGroup: builder.query({
      query: (inputGroupId) => {
        if (!inputGroupId) {
          return;
        }
        return {
          url: `/emissions/emission-input-groups/id/${inputGroupId}/`,
        };
      },

      providesTags: ["input-group"],
    }),
    getInputGroupListNew: builder.query({
      query: ({
        page = 1,
        limit = 100,
        carbon_order,
        activity_name,
        month_year,
        category,
        file_name,
        node_ids
      } = {}) => {
        const params = {
          page,
          limit,
          ...(carbon_order && { carbon_order }),
          ...(activity_name && { activity_name }),
          ...(month_year && { month_year }),
          ...(category && { category }),
          ...(file_name && { file_name }),
          ...(node_ids && {node_ids})
        };

        return {
          url: `/emissions/emission-input-items-bulk/`,
          params,
        };
      },
      providesTags: ["input-group"],
    }),
    getInputGroupList: builder.query({
      query: ({ page, limit, year, organization_taxonomy }) => {
        const params = {
          page,
          limit,
          year,
          organization_taxonomy,
        };

        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([_, v]) => v !== undefined)
        );

        return {
          url: `/emissions/emission-input-groups/`,
          params: filteredParams,
        };
      },
      providesTags: ["input-group"],
    }),

    inputGroupPeriods: builder.query({
      query: ({ company, site }) => {
        if (!company || !site) {
          return;
        }
        return {
          url: `/emissions/emission-input-groups/?company=${company}&company_site=${site}&limit=100`,
        };
      },
      providesTags: ["input-group"],
    }),
    deleteInputGroup: builder.mutation({
      query: (inputGroupId) => {
        return {
          url: `/emissions/delete-input-group/${inputGroupId}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["input-group"],
    }),
     getAllEmissionActivites: builder.query({
      query: ({
        page = 1,
        limit = 100,
        carbon_order,
        search_text,
        month_year,
        from_date,
        to_date,
        category,
        file_name,
        node_ids,
        aggregate,
        group_by,
        not_found_only,
      } = {}) => {
        const params = {
          page,
          limit,
          ...(carbon_order && { carbon_order }),
          ...(search_text && { search_text }),
          ...(month_year && { month_year }),
          ...(from_date && { from_date }),
          ...(to_date && { to_date }),
          ...(category && { category }),
          ...(file_name && { file_name }),
          ...(node_ids && {node_ids}),
          ...(aggregate !== undefined && aggregate !== "" && { aggregate }),
          ...(group_by && {group_by}),
          ...(not_found_only !== undefined && { not_found_only }),
        };

        return {
          url: `/emissions/emission-input-items-bulk-aggregate/`,
          params,
        };
      },
      providesTags: ["emission-activites"],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useCreateInputGroupMutation,
  useGetInputGroupQuery,
  useGetInputGroupListNewQuery,
  useGetInputGroupListQuery,
  useDeleteInputGroupMutation,
  useInputGroupPeriodsQuery,
  useGetAllEmissionActivitesQuery,
} = inputGroupApi;
